import type { LogFields } from './types'

function isPlainObject(value: unknown): value is Record<string, unknown> {
  if (typeof value !== 'object' || value === null) {
    return false
  }
  const prototype: unknown = Object.getPrototypeOf(value)
  return prototype === Object.prototype || prototype === null
}

function asFields(value: unknown): LogFields | undefined {
  if (value instanceof Error) {
    return { err: value }
  }
  return isPlainObject(value) ? value : undefined
}

// the types allow only (message, fields | Error), but a call through `any`, a cast or JavaScript can still
// pass the old pino order or a second string; those are read as (fields, message) or have the extra dropped
export function normalizeArguments(first: unknown, second: unknown): { message: string; fields: LogFields } {
  if (typeof first === 'string') {
    return { message: first, fields: asFields(second) ?? {} }
  }
  const fields = asFields(first)
  if (fields) {
    return { message: typeof second === 'string' ? second : '', fields }
  }
  return { message: '', fields: asFields(second) ?? {} }
}
